import React from "react";
// import CaseStudiesHome from "./CaseStudiesHome";
import HeroSection from "../../components/HeroSection";
import CaseStudyFeature from "./CaseStudyFeature";
import Footer from "../Footer/Footer";

const CaseStudies = () => {
  return (
    <>
      <HeroSection
        img="/Images/caseStudy.png"
        heading="case study on a company's website"
        subheading=" Abscod Solves  Challenge with Innovative Solutions"
        deatailhedaing="Case Studies
        Our digital marketing agency helps over 80 companies to increase consumer loyalty and find new customers online. Here, you’ll find a selection of our expert work. Take a look at some of the results we’ve delivered.
        "
      />
      {/* <CaseStudiesHome /> */}
      <CaseStudyFeature />
      <Footer />
    </>
  );
};

export default CaseStudies;
